// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"16510eff","195":"e6299f03","279":"54aca980","515":"95b12976","551":"a66e1f3d","787":"6254f411","791":"2a4566c0"}[chunkId] + ".chunk.js";
};